export enum ImagensProdutoDestaqueTipo {
  BANNER_PAGINA_PRODUTO = 0,
  ICONE = 1,
  THUMB_HOME_PAGE = 2,
  BANNER_CARTEIRA = 3,
}
